import { useFavicon } from "@vueuse/core";

const state = () => ({
  tenant: null
});

const getters = {
  tenant: state => {
    return state.tenant;
  }
};

const actions = {
  async fetchTenant({ commit }) {
    const { data } = await this.$http.get("app/fvn-operator");
    commit("setFVNOperator", data);
  }
};

const mutations = {
  setFVNOperator(state, data) {
    state.tenant = data;
    state.tenant.favicon = `https://api.globalfibra.com.br/app/fvn-operator-files/${state.tenant.favicon}`;
    state.tenant.logoLight = `https://api.globalfibra.com.br/app/fvn-operator-files/${state.tenant.logoLight}`;
    state.tenant.logoDark = `https://api.globalfibra.com.br/app/fvn-operator-files/${state.tenant.logoDark}`;
    document.title = `${state.tenant.name} - Dashboard`;
    useFavicon(state.tenant.favicon);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
